import EnumHelpers from '../Helpers/EnumHelpers'
import LocalizationStore from '../Stores/LocalizationStore'
import { CancelReason, CancelReasonEntity } from './CancelReasonModel'
import { QuestionnaireStatus } from './Questionnaire'

export function getQuestionnaireStatusSchema(status: QuestionnaireStatus): any {
    let keyValueCancelReason = EnumHelpers.toKeyValueArray(CancelReason)
    const lc = LocalizationStore.getInstance()
    if (status === QuestionnaireStatus.Canceled) {
        return {
            'type': 'object',
            'required': [
                'qId',
                'status',
                'comment'
            ],
            'properties': {
                'qId': {
                    'type': 'string'
                },
                'status': {
                    'type': 'number'
                },
                'cancelReason': {
                    title: LocalizationStore.getInstance().t('cancelReason'),
                    type: 'number',
                    enum: keyValueCancelReason.map(x => x.value),
                    enumNames: keyValueCancelReason.map(x => lc.t(x.key)),
                    default: CancelReasonEntity.getDefaultByRole()

                    // 'type': 'string' //EnumHelpers.values(QuestionnaireStatus)
                },
                'comment': {
                    title: LocalizationStore.getInstance().t('Add comment'),
                    'type': 'string'
                }
            }
        }
    } else {
        return {
            'type': 'object',
            'required': [
                'qId',
                'status',
                'comment'
            ],
            'properties': {
                'qId': {
                    'type': 'string'
                },
                'status': {
                    'type': 'number'
                },
                'comment': {
                    title: LocalizationStore.getInstance().t('Add comment'),
                    'type': 'string'
                }
            }
        }
    }
}

export const UIQuestionnaireStatusSchema = {
    'qId': {
        'ui:widget': 'hidden'
    },
    'status': {
        'ui:widget': 'hidden'
    },
    'comment': {
        'ui:widget': 'textarea'
    }
}

export const UICancelQuestionnaireStatusSchema = {
    'qId': {
        'ui:widget': 'hidden'
    },
    'status': {
        'ui:widget': 'hidden'
    },
    'comment': {
        'ui:widget': 'textarea'
    },
    'cancelReason': {
        'ui:enumDisabled': CancelReasonEntity.getBlockedReasonsByRole()
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/QStatusChangeFormModel.ts